import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-international-fide-rapid-rating-chess-tournament-pune',
  templateUrl: './international-fide-rapid-rating-chess-tournament-pune.component.html',
  styleUrls: ['./international-fide-rapid-rating-chess-tournament-pune.component.scss']
})
export class InternationalFideRapidRatingChessTournamentPuneComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
